import types from './types';

const logIn = ({ customerCode, isGlobalConfEditCustomer }) => (
  { type: types.LOG_IN, payload: { customerCode, isGlobalConfEditCustomer } }
);

const logOut = () => ({ type: types.LOG_OUT });

export default {
  logIn,
  logOut,
};
